import "core-js/es/string";
import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { createRoot } from 'react-dom/client';

// ReactDOM.render(<App />, document.getElementById("root"));
createRoot(document.getElementById("root")).render(<App />,);